import { buryPoint } from '@/Common/plugins/buried-point';
// import {
//   touristModePass,
// } from '@/Common/libs/touristModeUtils';

export default {
  intoConsolePage() {
    buryPoint.event({
      eventCategory: '浏览控制台',
      action: '浏览控制台-使用模块',
      eventLabel: '顶部导航Hik-ProConnect'
    });
  },
  targetToHome(type) {
    const op = {
      1: '登录访问',
      2: '左侧导航',
      3: '员工账号购买成功页-返回Home',
      4: '远程运维购买成功页-返回Home'
    };
    buryPoint.event({
      action: '浏览Home页-入口位置',
      eventCategory: '浏览Home页',
      eventLabel: op[type]
    });
  },
  changeLanguage() {
    buryPoint.event({
      action: '手动切换语言-使用功能',
      eventCategory: '手动切换语言'
    });
  },
  loginChangeCountry() {
    buryPoint.event({
      action: '手动切换国家-使用功能',
      eventCategory: '手动切换国家'
    });
  },
  triggerIPPosition() {
    buryPoint.event({
      action: '自动定位国家-使用功能',
      eventCategory: '自动定位国家'
    });
  },
  triggerIPPositionFail() {
    buryPoint.event({
      action: '自动定位国家-失败',
      eventCategory: '自动定位国家'
    });
  },
  freeMode() {
    buryPoint.event({
      action: '浏览Home页-免费模式',
      eventCategory: '浏览Home页'
    });
  },
  homepageBannerExposure(type) {
    buryPoint.event({
      action: '首页Banner-曝光量',
      eventCategory: '首页Banner',
      eventLabel: type
    });
  },
  homepageBannerClick(type) {
    buryPoint.event({
      action: '首页Banner-点击量',
      eventCategory: '首页Banner',
      eventLabel: type
    });
  },
  homePageAddServiceConfigClick() {
    buryPoint.event({
      action: 'Home页-配置增值服务-按钮点击',
      eventCategory: 'Home页-配置增值服务'
    });
  },
  addServiceConfigClickSite() {
    buryPoint.event({
      action: 'Home页-配置增值服务-完成站点选择',
      eventCategory: 'Home页-配置增值服务'
    });
  },
  additionalServicesDialogShow(type) {
    // 记录增值服务到期提醒弹窗的出现频次
    const opt = {
      1: '多个服务同时到期',
      2: '远程运维',
      3: '员工账号',
      4: '人员测温',
      5: '客流统计',
      6: '云存储',
      7: '设备运维服务到期'
    };
    buryPoint.event({
      eventCategory: '增值服务到期提醒',
      action: '增值服务到期提醒-出现提醒',
      eventLabel: opt[type]
    });
  },
  loginEvent(type) {
    const op = {
      1: '登录访问',
      2: '注册',
      3: '查看安装商证言视频'
    };
    buryPoint.event({
      eventCategory: '新登录页',
      action: `新登录页-${op[type]}`
    });
  },
  loginDialog(type, typeEvent) {
    const op = {
      1: '登录访问',
      2: 'HPC登录访问',
      3: '使用功能',
      4: '忘记密码',
      5: '已升级Onehikid登录失败'
    };
    const opEvent = {
      //   1: '新首页右上角登录',
      2: '注册弹窗-已有账号登录',
      3: '登录超时',
      //   4: 'demo顶部提示栏-登录',
      5: '新首页页面中间HPC登录按钮',
      6: '底部link-登录'
    };
    buryPoint.event({
      eventCategory: 'Login弹窗',
      action: `Login弹窗-${op[type]}`,
      eventLabel: opEvent[typeEvent] || null
    });
  },
  registerDialog(type, typeEvent) {
    // [事件操作，...事件标签]
    const USER = localStorage.getItem('chooseType') ? '-终端用户' : '-服务商';
    const op = {
      1: [
        '注册访问-验证邮箱',
        `新首页右上角${USER}`,
        `登录弹窗-没有账号？立即注册${USER}`,
        `demo顶部提示栏-注册${USER}`,
        `页面底部快速链接-注册${USER}`
      ],
      2: ['发送验证码'],
      3: ['重新获取验证码'],
      4: ['未收到验证码'],
      5: ['验证邮箱', `正确${USER}`, `错误${USER}`],
      6: ['注册访问', `认证码必填${USER}`, `认证码选填${USER}`, `不需要验证码${USER}`],
      7: ['完成注册', `认证码必填${USER}`, `认证码选填${USER}`, `不需要验证码${USER}`],
      8: [
        '注册结果',
        `注册成功${USER}`,
        `注册失败，邮箱已存在${USER}`,
        `注册失败，邮件验证码错误${USER}`,
        `注册失败，邮件验证码过期${USER}`,
        `注册失败，邮件验证码尝试超过最大次数${USER}`,
        `B账户池已空${USER}`,
        `IP代表国家与认证码代表国家不一致${USER}`,
        `其他${USER}`
      ],
      9: ['营销活动订阅']
    };

    buryPoint.event({
      eventCategory: 'admin注册弹窗（HPC注册）',
      action: `${op[type][0]}`,
      eventLabel: op[type][typeEvent] || null
    });
  },
  registerClick(type) {
    // [事件操作，...事件标签]
    const op = {
      1: '新首页右上角-注册',
      2: '登录弹窗-没有账号？立即注册',
      //   3: 'demo顶部提示栏-注册',
      4: '页面底部快速链接-注册'
    };

    buryPoint.event({
      eventCategory: 'admin注册弹窗（HPC注册）',
      action: `点击注册`,
      eventLabel: op[type] || null
    });
  },
  demoUseEvent(type) {
    const op = {
      1: '新登录页-体验Demo',
      2: '首次登陆自动弹出',
      3: 'Home页-右侧常驻栏目-体验demo',
      4: 'Home页-顶部下拉选项-体验demo',
      5: '教学中心-体验demo'
    };
    buryPoint.event({
      eventCategory: 'demo',
      action: 'demo-使用功能',
      eventLabel: op[type]
    });
  },
  // @touristModePass
  demoGoModuleEvent(type) {
    const op = {
      1: '首页',
      2: '站点',
      3: '更多功能',
      4: '健康监测',
      5: '异常中心',
      6: '公司'
    };
    buryPoint.event({
      eventCategory: 'Demo',
      action: 'Demo-Demo引导曝光量',
      eventLabel: op[type]
    });
  },
  demoTime(value, eventLabel) {
    buryPoint.timing({
      name: 'Demo-Demo使用时长',
      value,
      eventCategory: 'Demo',
      eventLabel
    });
  },
  maunallySalesEvent() {
    buryPoint.event({
      action: '打折促销活动-年度促销弹窗',
      eventCategory: '打折促销活动'
    });
  },
  clickSalesEvent() {
    buryPoint.event({
      action: '打折促销活动-点击弹窗',
      eventCategory: '打折促销活动'
    });
  },
  cloudStorageBannerClick() {
    buryPoint.event({
      action: '云存储推广-banner按钮点击',
      eventCategory: '云存储推广'
    });
  },
  cloudStorageBannerAddDeviceClick() {
    buryPoint.event({
      action: '云存储推广-需要云存储的理由-按钮点击',
      eventCategory: '云存储推广'
    });
  },
  clickCompatibilityTab(flag) {
    const op = {
      0: '封面',
      1: '兼容性列表',
      2: '云考勤&门禁',
      3: '云存储NVR',
      4: '云存储DVR',
      5: '云存储盒子',
      6: '利旧盒子',
      7: '人员测温服务',
      8: '人员统计服务'
    };
    buryPoint.event({
      action: '兼容性列表-浏览tab',
      eventCategory: '兼容性列表',
      eventLabel: op[flag]
    });
  },
  searchCompatibilityOnTab(flag) {
    const op = {
      0: '封面',
      1: '兼容性列表',
      2: '云考勤&门禁',
      3: '云存储NVR',
      4: '云存储DVR',
      5: '云存储盒子',
      6: '利旧盒子',
      7: '人员测温服务',
      8: '人员统计服务'
    };
    buryPoint.event({
      action: '兼容性列表-搜索',
      eventCategory: '兼容性列表',
      eventLabel: op[flag]
    });
  },
  functionHelpTipsShow(where) {
    buryPoint.event({
      eventCategory: '功能页帮助材料入口',
      action: '功能页帮助材料入口-出现tips提示',
      eventLabel: where
    });
  },
  functionHelpTipsClose(where) {
    buryPoint.event({
      eventCategory: '功能页帮助材料入口',
      action: '功能页帮助材料入口-手动关闭tips',
      eventLabel: where
    });
  },
  functionHelpTipsOpenPicture(where) {
    buryPoint.event({
      eventCategory: '功能页帮助材料入口',
      action: '功能页帮助材料入口-出现帮助文档弹窗',
      eventLabel: where
    });
  },
  functionHelpTipsOpenVideo(where) {
    buryPoint.event({
      eventCategory: '功能页帮助材料入口',
      action: '功能页帮助材料入口-出现视频弹窗',
      eventLabel: where
    });
  },
  appearAuthorization() {
    buryPoint.event({
      eventCategory: '售后服务码',
      action: '售后服务码-出现生成授权码弹窗'
    });
  },
  produceAuthorization() {
    buryPoint.event({
      eventCategory: '售后服务码',
      action: '售后服务码-生成授权码'
    });
  },
  copyAuthorization() {
    buryPoint.event({
      eventCategory: '售后服务码',
      action: '售后服务码-复制授权码'
    });
  },
  abandonedAuthorization() {
    buryPoint.event({
      eventCategory: '售后服务码',
      action: '售后服务码-废弃授权码'
    });
  },
  extendAuthorization() {
    buryPoint.event({
      eventCategory: '售后服务码',
      action: '售后服务码-延迟有效期'
    });
  },
  loseAuthorization() {
    buryPoint.event({
      eventCategory: '售后服务码',
      action: '售后服务码-授权码失效'
    });
  },
  againProduceAuthorization() {
    buryPoint.event({
      eventCategory: '售后服务码',
      action: '售后服务码-重新生成'
    });
  },
  pageHandleEvent(type) {
    const op = {
      1: 'banner（所有的banner点击）',
      2: 'site overview-view all',
      3: 'site overview-创建站点',
      4: 'site overview-添加设备',
      5: 'for the first-time usage…-创建站点',
      6: 'for the first-time usage…-添加设备',
      7: 'site overview-最近访问站点',
      8: 'device overview-view all',
      9: 'exception notification overview-view all',
      10: 'exception notification overview-各类异常柱状图',
      11: '云存储-添加云存储设备',
      12: '云存储-learn more',
      13: 'more value-added service-set',
      14: '积分-get started',
      15: '积分-添加设备',
      16: 'feedback',
      17: '教学中心-view all',
      18: '教学中心-tab项',
      19: '教学中心-内容条目',
      20: 'tools',
      21: '设备兼容性列表',
      22: '用户手册',
      23: 'datesheet',
      24: `what's new`,
      25: '最近常用功能（卡片的所有按钮）',
      26: '悬浮气泡按钮（所有按钮，不包括收起展开）'
    };
    buryPoint.event({
      action: '浏览Home页-按钮点击',
      eventCategory: '浏览Home页',
      eventLabel: op[type]
    });
  },
  upgradeDialogShow(version) {
    buryPoint.event({
      eventCategory: '在线更新说明',
      action: '出现更新弹框',
      eventLabel: version
    });
  },
  upgradeDialogViewAll() {
    buryPoint.event({
      eventCategory: '在线更新说明',
      action: '更新弹窗-查看更多'
    });
  },
  upgradeHomeViewAll() {
    buryPoint.event({
      eventCategory: '在线更新说明',
      action: '在线更新卡片-查看全部'
    });
  },
  clickSupport(type) {
    const op = {
      1: '顶部导航栏',
      2: '首页',
      3: '快捷导航'
    };
    buryPoint.event({
      eventCategory: '工单',
      action: '工单-点击支持',
      eventLabel: op[type]
    });
  },
  supportUnauthed() {
    buryPoint.event({
      eventCategory: '工单',
      action: '工单-未认证'
    });
  },
  viewSupportSubmit() {
    buryPoint.event({
      eventCategory: '工单',
      action: '工单-提交工单页面访问'
    });
  },
  viewSupportRecords() {
    buryPoint.event({
      eventCategory: '工单',
      action: '工单-访问工单记录'
    });
  },
  viewSupportDetail(type) {
    const op = {
      1: '支持-工单记录列表',
      2: '工单通知邮件-链接'
    };
    buryPoint.event({
      eventCategory: '工单',
      action: '工单-工单详情页访问',
      eventLabel: op[type]
    });
  },
  supportFeedback() {
    buryPoint.event({
      eventCategory: '工单',
      action: '工单-在线反馈'
    });
  },
  toHPCAtFirst() {
    buryPoint.event({
      eventCategory: '浏览新home页',
      action: '直接接入Hik-ProConnect'
    });
  },
  toHPCLogin() {
    buryPoint.event({
      eventCategory: '浏览新home页',
      action: '使用模块'
    });
  },
  newPageBtn(type) {
    const op = {
      1: '顶部导航-home',
      2: '顶部导航-Hik-ProConnect',
      3: '顶部导航-Product',
      4: '顶部导航-explore',
      5: '顶部导航-solution',
      6: '顶部导航-support',
      7: '顶部导航-教学中心',
      8: '顶部导航-my company',
      9: '顶部导航-签到',
      10: '顶部导航-我的积分',
      11: '顶部导航-消息中心',
      12: '顶部导航-切换品牌',
      13: '顶部导航-切换语言',
      14: '顶部导航-账号下拉',
      15: 'banner点击',
      16: '添加站点',
      17: '添加设备',
      18: '添加HCC系统',
      19: '悬浮-积分签到',
      20: '悬浮-积分商城',
      21: '资讯-推荐内容',
      22: '资讯-更多推荐',
      23: '资讯-热点产品',
      24: '资讯-更多热点产品',
      25: '资讯-热点方案',
      26: '资讯-更多热点方案',
      27: '资讯-活动',
      28: '资讯–更多活动',
      29: '资讯-教学中心',
      30: '资讯-更多教学',
      31: '顶部导航-Project',
      32: '顶部导航-Order&Promotion',
      33: '顶部导航-Incentive'
    };
    buryPoint.event({
      eventCategory: 'EP新Home页',
      action: 'EP新Home页-按钮点击',
      eventLabel: op[type]
    });
  },
  productsService(type) {
    const op = {
      1: '热门产品tab',
      2: '项目注册tab',
      3: '资源中心tab',
      4: '增值服务tab',
      5: '热门产品卡片内容点击',
      6: '查看更多热门产品',
      7: '注册新项目',
      8: '资源中心内容点击'
    };
    buryPoint.event({
      eventCategory: 'EP新Home页',
      action: 'productsService',
      eventLabel: op[type]
    });
  },
  bottomIconLink(type) {
    const op = {
      1: 'Device compatibility list',
      2: 'user manual',
      3: 'dateSheet',
      4: "what's new"
    };
    buryPoint.event({
      eventCategory: 'bottomIconLink',
      action: 'bottomIconLink',
      eventLabel: op[type]
    });
  },
  bottomWordLink(type) {
    const op = {
      1: 'where to buy',
      2: 'HikVision website',
      3: 'Technology partner portal',
      4: 'eLearning',
      5: 'Privacy policy',
      6: 'Terms of use',
      7: 'B2B2 Terms and Condition',
      8: 'FAQ'
    };
    buryPoint.event({
      eventCategory: 'bottomWordLink',
      action: 'bottomWordLink',
      eventLabel: op[type]
    });
  },
  pointsMall(type) {
    const op = {
      1: 'PointsMall主页_导航栏入口',
      2: '签到模块_签到',
      3: '签到模块_查看签到规则'
    };
    buryPoint.event({
      eventCategory: 'PointsMall',
      action: 'entrance_signIn',
      eventLabel: op[type]
    });
  },
  inviteFriends(type) {
    const op = {
      1: '邀请好友页面_浏览信息',
      2: '邀请好友页面_邀请码复制按钮',
      3: '邀请好友页面_链接复制按钮',
      4: '邀请记录页面_浏览信息'
    };
    buryPoint.event({
      eventCategory: 'PointsMall',
      action: 'inviteFriends',
      eventLabel: op[type]
    });
  },
  inviteFriendsTime(time) {
    buryPoint.timing({
      name: 'inviteFriendsTime',
      value: time,
      eventCategory: 'PointsMall',
      eventLabel: '邀请好友页面_浏览时长'
    });
  },
  inviteFriendsRecordsTime(time) {
    buryPoint.timing({
      name: 'inviteFriendsRecordsTime',
      value: time,
      eventCategory: 'PointsMall',
      eventLabel: '邀请记录页面_浏览时长'
    });
  },
  noticePopBrowse() {
    buryPoint.event({
      eventLabel: 'Notice弹窗_浏览信息',
      eventCategory: 'Notice',
      action: 'Notice-查看信息'
    });
  },
  noticePopBrowseTiming(value) {
    buryPoint.timing({
      eventLabel: 'Notice弹窗_浏览信息',
      eventCategory: 'Notice',
      name: 'Notice-使用时长',
      value
    });
  },
  noticePopPos() {
    buryPoint.event({
      eventLabel: 'Notice弹窗_主页入口',
      eventCategory: 'Notice',
      action: 'Notice-入口位置'
    });
  },
  noticePopClick(type) {
    const op = {
      1: 'Notice弹窗_关闭按钮',
      2: 'Notice弹窗_不再提醒选项',
      3: 'Notice弹窗_已了解按钮'
    };
    buryPoint.event({
      eventLabel: op[type],
      eventCategory: 'Notice',
      action: 'Notice-点击行为'
    });
  },
  clickHPC() {
    buryPoint.event({
      eventCategory: 'EP新Home页',
      action: 'EP新Home页-直接点击Hik-ProConnect菜单'
    });
  },
  clickFunctionAtHome(flag) {
    const op = {
      1: '顶部导航-全局搜索',
      2: '顶部导航-签到',
      3: '顶部导航-公司主体切换',
      4: '顶部导航-消息',
      5: 'banner',
      6: 'explore-feeds内容点击',
      7: 'explore-event内容点击',
      8: 'explore-更多',
      9: '积分-签到',
      10: '积分-更多',
      11: 'support-在线工单',
      12: 'support-问题反馈',
      13: '工具-批量配置',
      14: '工具-批量升级',
      15: '工具-固件查询',
      16: '工具-硬盘容量计算',
      17: '工具-更多',
      18: '教学中心-内容点击',
      19: 'how to-内容点击',
      20: '教学中心-查看更多',
      21: 'how to-查看更多',
      22: '新手引导-添加设备',
      23: '站点设备概览-创建站点',
      24: '站点设备概览-添加设备',
      25: '站点设备概览-最近访问站点',
      26: '站点设备概览-帮助',
      27: '健康监测-去激活',
      28: '健康监测-更多',
      29: '异常通知概览-更多'
    };
    buryPoint.event({
      eventCategory: 'HPP新Home页',
      action: 'HPP新Home页-按钮点击',
      eventLabel: op[flag]
    });
  },
  defaultPage(type) {
    const op = {
      1: '弹出DefaultPage',
      2: 'DefaultPage点击OK'
    };
    buryPoint.event({
      eventLabel: op[type],
      eventCategory: 'Home页',
      action: 'Home页-DefaultPage'
    });
  }
};
